<style src="./ReportOpenedDebits.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content report-opened-debits">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="searchWithFilter">
        <div class="row">
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Veículo</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  placeholder="ABC-1234"
                  class="form-control"
                  v-model="licencePlate"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Data Inicial</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  placeholder="30/12/2019"
                  class="form-control"
                  v-model="startDate"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Hora Inicial</label>
              <div class="col-sm-12">
                <input
                  type="time"
                  placeholder="09:00:00"
                  class="form-control"
                  v-model="startTime"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Data final</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  placeholder="30/12/2019"
                  class="form-control"
                  v-model="endDate"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Hora Final</label>
              <div class="col-sm-12">
                <input
                  type="time"
                  placeholder="15:00:00"
                  class="form-control"
                  v-model="endTime"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>

          <div class="exportbuttom col-sm-2">
            <button
              class="btn btn-lg btn-primary"
              type="button"
              @click="exportCsv"
            >
              <i class="fa fa-download"></i>
              Exportar CSV
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <!-- <div class="ibox-content">
      <div class="alert alert-info col-sm-4">
        Valor Total em Notificações:
        <strong>R$ {{ totalAmount | totalToCurrencyBR }}</strong>
      </div>

      <div class="col-sm-4">
      </div>

      <div class="alert alert-info col-sm-4">
        Quantidade de Notificações:
        <strong>R$ {{ countDebits }}</strong>
      </div>
    </div> -->

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <th>Placa</th>
          <th>Débito R$</th>
          <th>Qt Débitos</th>
        </thead>
        <tbody>
          <tr
            class="read"
            v-for="(item, idx) in resultList"
            :key="idx"
            @click="openVehicleHistoryDetail(item)"
          >
            <td>{{ item._id.licencePlate }}</td>
            <td>{{ item.totalAmountPaid | totalToCurrencyBR }}</td>
            <td>{{ item.countDebits }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn-group paginatecontent" v-if="countPages > 0">
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>

      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      form: {
        pageSkip: 0,
        pageLimit: 30,
      },
      licencePlate: '',
      startDate: new Date(),
      endDate: new Date(),
      startTime: '00:00:00',
      endTime: '23:00:00',
      countPages: 0,
      resultList: [],
      countDebits: 0,
      totalAmount: 0,
      walletTotal: 0,
      cashTotal: 0,
    };
  },
  filters: {
    fillDate(value) {
      return new Date(value).toLocaleDateString('pt-BR');
    },
    fillTime(value) {
      return new Date(value).toLocaleTimeString('pt-BR');
    },
    formatLicencePlate(licencePlate) {
      return licencePlate.toUpperCase();
    },
    totalToCurrencyBR(value) {
      if (!value) {
        return '-';
      }
      // return (value / 100).toFixed(2).toString().replace('.', ',');
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
  },
  computed: {
    hasPageLeft() {
      return this.form.pageSkip === 0;
    },
    hasPageRight() {
      return this.form.pageSkip + this.form.pageLimit >= this.countPages;
    },
  },
  mounted() {},
  methods: {
    openVehicleHistoryDetail(item) {
      let routeData = this.$router.resolve({
        name: 'VehicleHistoryWithLicencePlate',
        params: { licencePlate: item._id.licencePlate },
      });
      window.open(routeData.href, '_blank');
    },
    searchWithFilter() {
      this.pageSkip = 0;
      this.filterReport();
    },
    async exportCsv() {
      this.showSpinner = true;
      const query = {};

      if (this.licencePlate) {
        query.licencePlate = this.licencePlate;
      }

      if (this.startDate) {
        if (!this.startTime) {
          this.startTime = '00:00';
        }
        query.startDate = new Date(`${this.startDate} ${this.startTime}:00`);
      }

      if (this.endDate) {
        if (!this.endTime) {
          this.endTime = '00:00';
        }
        query.endDate = new Date(`${this.endDate} ${this.endTime}:00`);
      }

      try {
        const response = await this.$store.dispatch(
          'REPORTS/DownloadOpenedDebitsCsv',
          {
            query,
          },
        );

        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'VEICULO DEVEDOR.csv');
        document.body.appendChild(link);
        link.click();
      } catch (errors) {
        this.resultList = [];
      } finally {
        this.showSpinner = false;
      }
    },
    async filterReport() {
      this.showSpinner = true;
      this.resultList = [];

      const query = {
        ...this.form,
      };

      if (this.licencePlate) {
        query.licencePlate = this.licencePlate;
      }

      if (this.startDate) {
        if (!this.startTime) {
          this.startTime = '00:00';
        }
        query.startDate = new Date(`${this.startDate} ${this.startTime}:00`);
      }

      if (this.endDate) {
        if (!this.endTime) {
          this.endTime = '00:00';
        }
        query.endDate = new Date(`${this.endDate} ${this.endTime}:00`);
      }

      try {
        const reports = await this.$store.dispatch(
          'REPORTS/ReportOpenedDebits',
          {
            query,
          },
        );

        this.countPages = reports.countTotal;
        this.totalAmount = reports.totalAmount;
        this.countDebits = reports.countDebits;
        this.resultList = reports.result;
      } catch (errors) {
        this.resultList = [];
      } finally {
        this.showSpinner = false;
      }
    },
    nextPage() {
      if (this.form.pageSkip + this.form.pageLimit > this.countPages) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip + this.form.pageLimit;

      this.filterReport();
    },
    previousPage() {
      if (this.form.pageSkip === 0) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip - this.form.pageLimit;

      this.filterReport();
    },
  },
};
</script>
